"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _MuiTablePagination = _interopRequireDefault(require("./MuiTablePagination/MuiTablePagination"));

var MuiPaginationTableFooter = function MuiPaginationTableFooter(_ref) {
  var rootClass = _ref.rootClass,
      labelRowsPerPage = _ref.labelRowsPerPage,
      rowsPerPageOptions = _ref.rowsPerPageOptions,
      numRows = _ref.numRows,
      page = _ref.page,
      handleChangeRows = _ref.handleChangeRows,
      rowsPerPage = _ref.rowsPerPage,
      handlePageChange = _ref.handlePageChange;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.TableFooter, {
    className: styles.root
  }, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_MuiTablePagination.default, {
    labelRowsPerPage: labelRowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    numRows: numRows,
    page: page,
    handleChangeRows: handleChangeRows,
    rowsPerPage: rowsPerPage,
    handlePageChange: handlePageChange
  })));
};

var _default = MuiPaginationTableFooter;
exports.default = _default;
MuiPaginationTableFooter.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'Rows per page:'
   * Customize the rows per page label.
   */
  labelRowsPerPage: _propTypes.default.node,

  /**
   * mui prop: 0
   * displays page of table display.
   */
  page: _propTypes.default.number,

  /**
   * func
   * Set the number of rows in table.
   */
  // eslint-disable-next-line react/require-default-props
  handleChangeRows: _propTypes.default.func,

  /**
   * default number displayed: 10
   * The number of rows displayed on table per page.
   */
  rowsPerPage: _propTypes.default.number,

  /**
   * mui prop: [10, 25, 50, 100]
   * Customizes the options of the rows per page select field.
   * If less than two options are available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * mui prop: 0
   * Number of rows in table.
   */
  numRows: _propTypes.default.number,

  /**
   * function
   * Changes the page of table
   */
  // eslint-disable-next-line react/require-default-props
  handlePageChange: _propTypes.default.func
};
MuiPaginationTableFooter.defaultProps = {
  labelRowsPerPage: 'Rows per page:',
  numRows: 0,
  page: 0,
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 25, 50, 100],
  rootClass: []
};